import { render, staticRenderFns } from "./DropeZone.vue?vue&type=template&id=2da8a806&"
import script from "./DropeZone.vue?vue&type=script&lang=js&"
export * from "./DropeZone.vue?vue&type=script&lang=js&"
import style0 from "./DropeZone.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports